import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=07c62a4a&scoped=true&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style0 from "./Image.vue?vue&type=style&index=0&id=07c62a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c62a4a",
  null
  
)

export default component.exports